import { render, staticRenderFns } from "./StandardHome.vue?vue&type=template&id=03257e54&scoped=true&"
import script from "./StandardHome.vue?vue&type=script&lang=js&"
export * from "./StandardHome.vue?vue&type=script&lang=js&"
import style0 from "./StandardHome.vue?vue&type=style&index=0&id=03257e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03257e54",
  null
  
)

export default component.exports